import { useMemo } from "react";
import {
  BOILER_TYPE_GROUND,
  BOILER_TYPE_WALL,
  boilerTypeToArray,
} from "utils/helpers/boilerType";
import { objectifOptions } from "./useFilterConfig";

export const useAppliedFilterValue = ({
  appliedSolutionFilter,
  appointPuissanceTotale,
}: {
  appliedSolutionFilter?: GetSolutionRequest | null;
  appointPuissanceTotale?: number;
}) => {
  const result = useMemo(() => {
    const {
      hauteur_porte: default_hauteur_porte,
      largeur_porte: default_largeur_porte,
      code_gamme_pac: default_code_gamme_pac,
      traitement_anti_corrosion,
      filtres,
    } = (appliedSolutionFilter || {}) as GetSolutionRequest;

    const { preference_pac: default_preference_pac } = (filtres ?? {}) as {
      appoint?: boolean[];
      part_pac?: number;
      taux_couverture?: number;
      preference_pac?: string[];
      charge_acoustique: number;
      abonnement_elec: number;
    };
    const isWallBoilerDisabled = (appointPuissanceTotale ?? 0) > 150;
    const rawTypeChaudiere = (filtres as any)?.type_chaudiere;

    const allowedTypeChaudiereValues = isWallBoilerDisabled
      ? [BOILER_TYPE_GROUND]
      : [BOILER_TYPE_GROUND, BOILER_TYPE_WALL];

    const mappedTypeChaudiereValues = boilerTypeToArray(rawTypeChaudiere).filter(
      (v) => allowedTypeChaudiereValues.includes(v)
    );
    const isMissingPersistedBoilerType =
      rawTypeChaudiere === undefined || rawTypeChaudiere === null;

    const defaultValues = {
      hauteur_porte: default_hauteur_porte,
      largeur_porte: default_largeur_porte,
      code_gamme_pac: default_code_gamme_pac,
      ...(filtres || {}),
      preference_pac: !default_preference_pac
        ? undefined
        : default_preference_pac,
      objectif: Object.keys(filtres || {}).find((key) =>
        objectifOptions.some((opt) => opt.value == key)
      ),
      type_chaudiere: isMissingPersistedBoilerType
        ? allowedTypeChaudiereValues
        : mappedTypeChaudiereValues,
    };

    return { defaultValues, traitement_anti_corrosion };
  }, [appliedSolutionFilter, appointPuissanceTotale]);

  return result;
};
